var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('entity-crud',_vm._b({},'entity-crud',{ model: _vm.model, title: _vm.title, tableColumns: _vm.tableColumns, filter: _vm.filter, formColumns: _vm.formColumns, defaultEntity: _vm.defaultEntity },false))}
var staticRenderFns = []

export { render, staticRenderFns }